import { render, staticRenderFns } from "./QuotationPoster.vue?vue&type=template&id=2e57b1cc&scoped=true&"
import script from "./QuotationPoster.vue?vue&type=script&lang=js&"
export * from "./QuotationPoster.vue?vue&type=script&lang=js&"
import style0 from "./QuotationPoster.vue?vue&type=style&index=0&id=2e57b1cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e57b1cc",
  null
  
)

export default component.exports